<script>

	export default {
		data() {
			return {
				sections: [
					{
						"id": 1,
						"title": "Video Streaming",
						"description": "Select the quality you want to stream video content (series, movies and YouTube etc.) at.",
						"default_speed": 4,
						"options": [
							{
								"title": "Standard definition - 480p",
								"description": "Similar quality to old tube-based analog TVs",
								"speed": 4,
								"icon": "tv-standard"
							},
							{
								"title": "Full high definition - 1080p",
								"description": "Used by most flat screen TVs and devices on the market",
								"speed": 5,
								"icon": "tv-high-def",
								"recommended": true
							},
							{
								"title": "Ultra high definition - 4K",
								"description": "Used by the latest and greatest TV’s and computers",
								"speed": 7,
								"icon": "tv-4k"
							}
						]
					},
					{
						"id": 2,
						"title": "Gaming",
						"description": "Which kind of game player are you?",
						"default_speed": 4,
						"options": [
							{
								"title": "Recreational",
								"description": "Recreational games like those on your smartphone",
								"speed": 4,
								"icon": "three-stars"
							},
							{
								"title": "General",
								"description": "Strategy and general games like Starcraft",
								"speed": 5,
								"icon": "swords"
							},
							{
								"title": "MMO and FPS",
								"description": "MMO (Massively Multiplayer), First-Person Shooter and next-gen console games",
								"speed": 8,
								"icon": "gamepad"
							}
						]
					},
					{
						"id": 3,
						"title": "Users and Devices",
						"default_speed": 4,
						"description": "How many people or smart devices will be using the Internet connection at any given time?",
						"options": [
							{
								"title": "1 Person",
								"description": "1 TV, 1 computer, 1 smartphone or 1 tablet",
								"speed": 4,
								"icon": "person"
							},
							{
								"title": "2 People",
								"description": "Up to 2 TVs, 2 computers or multiple smart devices",
								"speed": 5,
								"icon": "two-people"
							},
							{
								"title": "3-5 People",
								"description": "Multiple TVs, computers and smart devices",
								"speed": 6,
								"icon": "three-people"
							},
							{
								"title": "Families",
								"description": "Enough Internet loving for the entire family to stay entertained",
								"speed": 8,
								"icon": "family"
							}
						]
					},
					{
						"id": 4,
						"title": "The Cloud",
						"description": "How will you be using connected devices and services?",
						"default_speed": 4,
						"options": [
							{
								"title": "Not really",
								"description": "I won’t be syncing any of my data with the Cloud",
								"speed": 3,
								"icon": "cloud-no-access"
							},
							{
								"title": "A little bit",
								"description": "I’ll sync some things via the Cloud like photos and music",
								"speed": 5,
								"icon": "camera-music",
								"recommended": true
							},
							{
								"title": "Digital lifestyle",
								"description": "My devices and services need to be in sync at all times",
								"speed": 6,
								"icon": "smart-phone"
							},
							{
								"title": "I live in the Cloud",
								"description": "I need full online backups and services in sync via the Cloud",
								"speed": 9,
								"icon": "cloud-sync"
							}
						]
					}
				],
				speeds: [
					{
						"id": 1,
						"speed": "4Mbps+",
						"cookie_value": "4Mbps"
					},
					{
						"id": 2,
						"speed": "4Mbps+",
						"cookie_value": "4Mbps"
					},
					{
						"id": 3,
						"speed": "10Mbps+",
						"cookie_value": "10Mbps"
					},
					{
						"id": 4,
						"speed": "10Mbps+",
						"cookie_value": "10Mbps"
					},
					{
						"id": 5,
						"speed": "20Mbps+",
						"cookie_value": "20Mbps"
					},
					{
						"id": 6,
						"speed": "25Mbps+",
						"cookie_value": "25Mbps"
					},
					{
						"id": 7,
						"speed": "40Mbps+",
						"cookie_value": "40Mbps"
					},
					{
						"id": 8,
						"speed": "50Mbps+",
						"cookie_value": "50Mbps"
					},
					{
						"id": 9,
						"speed": "100Mbps+",
						"cookie_value": "100Mbps"
					}
				],
				activeSection: 0,
				error: false,
				suggestion: false,
				direction: 'forward',
				showError: false,
				baseUrl: window._baseUrl,
				touchDeviceHeight: 'short',
				isMobile: window.innerWidth <= 600,

				// spiderman
				canPlayGame: false
			}
		},
		methods: {

			nextStep() {
				this.direction = 'forward';
				this.suggestion = false;

				if (this.activeSection === 4) {
					return false;
				}

				// if on the last step, calculate the suggestion
				if ((this.activeSection + 1) === this.sections.length) {

					// pick the highest
					let flag = 0;
					this.sections.forEach(section => {
						if (section.selected && section.selected > flag) {
							flag = section.selected;
						}
					});

					if (flag > 0) {
						this.showError = false;
						this.speeds.forEach(speed => {
							if (speed.id === flag) {
								this.suggestion = speed;
								// console.log(this.suggestion);
							}
						});
					} else {
						this.showError = true;
						return false;
					}

					this.activeSection++;
					return false;
				}

				// check for selection and change section
				if (this.sections[this.activeSection].selected !== false) {
					this.error = false;
					this.activeSection++;
					return false;
				}

				this.error = true;
			},

			previousStep() {
				this.direction = 'reverse';

				if(this.activeSection === 4) {
					return false;
				}

				if(this.activeSection > 0) {
					this.activeSection--;
				}
			},

			restart() {
				this.sections.forEach(section => {
					section.selected = false;
				});

				this.activeSection = 0;
				this.error = false;
				this.showError = false;
				this.touchDeviceHeight = 'short';
			},

			makeSelection(index) {
				this.error = false;
				this.sections[this.activeSection].selected = index;

				this.nextStep();

				// mobile scroll to top
				if (this.isMobile) {
					this.$scrollTo('.section-header')
				}

				// mobile heights
				if (this.sections[this.activeSection] && this.sections[this.activeSection].options.length <= 3) {
					this.touchDeviceHeight = 'short';
				} else {
					this.touchDeviceHeight = 'long';
				}

			},

		},
		created() {
			// set the default value on each section to false
			this.sections.forEach(section => {
				section.selected = false;
			});
		}
	}
</script>

<template>
    <div class="wizard-holder">
        <div class="breadcrumbs">
            <div :class="`bar s${activeSection}`"></div>

            <dl :class="{ 'is-selected': activeSection === 0, 'pre-selected': activeSection > 0 }">
                <dt><span>1</span></dt>
                <dd>Video Streaming</dd>
            </dl>
            <dl :class="{ 'is-selected': activeSection === 1, 'pre-selected': activeSection > 1 }">
                <dt><span>2</span></dt>
                <dd>Gaming</dd>
            </dl>
            <dl :class="{ 'is-selected': activeSection === 2, 'pre-selected': activeSection > 2 }">
                <dt><span>3</span></dt>
                <dd>Users &amp; Devices</dd>
            </dl>
            <dl :class="{ 'is-selected': activeSection === 3, 'pre-selected': activeSection > 3 }">
                <dt><span>4</span></dt>
                <dd>The Cloud</dd>
            </dl>
            <dl :class="{ 'is-selected': activeSection === 4, 'pre-selected': activeSection > 4 }">
                <dt><span>5</span></dt>
                <dd>Suggested Speed</dd>
            </dl>

        </div> <!-- end.breadcrumbs -->

        <div class="section-holder">
            <dl class="section-header" v-if="activeSection < 4 && !showError">
                <dt>{{ sections[activeSection].title }}</dt>
                <dd>{{ sections[activeSection].description }}</dd>
            </dl>

            <p class="error" :class="{ 'is-visible': error }">Please make a selection to continue to the next step</p>

            <div :class="[`pod-holder direction-${direction}`, { 'show-results': activeSection === 4 }, `touch-${touchDeviceHeight}`]" v-if="!showError">
                <div v-for="(group, g) in sections" :key="g" :class="[`pod-group s${group.options.length}`, { 'is-visible': g === activeSection }]">
                    <div v-for="(option, index) in group.options" :key="index" @click="makeSelection(option.speed)"
                         class="pod" :class="{ 'is-selected': group.selected === option.speed }">
                        <span class="violator" v-if="option.recommended"></span>
                        <dl>
                            <svg><use :xlink:href="`#${option.icon}`"></use></svg>
                            <dt>{{ option.title }}</dt>
                            <dd>{{ option.description }}</dd>
                        </dl>
                        <label>
                            <span class="text">Select</span>
                        </label>
                    </div> <!-- end.pod -->
                </div>

                <div class="results-holder" :class="{ 'is-visible': activeSection === 4 }">
                    <dl>
                        <dt>{{ suggestion.speed }}</dt>
                        <dd>We suggest you get a line speed of at least {{ suggestion.speed }}.</dd>
                        <a :href="baseUrl" class="btn gradient-red">Check Coverage in your Area</a>
                    </dl>
                    <span class="fibre-logo"></span>
                </div> <!-- end.results-holder -->

            </div> <!-- end.pod-holder -->

            <div class="error-holder" v-if="showError"></div> <!-- end.error-holder -->

            <div class="action-bar">
                <a class="btn"
                   @click="makeSelection(sections[activeSection].default_speed)"
                   :class="{ 'is-selected': sections[activeSection].selected === sections[activeSection].default_speed }"
                   v-if="activeSection < 4 && !showError">
                    <span>I Don't Know</span>
                </a>
                <a class="btn"
                   @click="makeSelection(0)"
                   :class="{ 'is-selected': sections[activeSection].selected === 0 }"
                   v-if="activeSection < 4 && !showError">
                    <span>Not Applicable</span>
                </a>
                <a class="btn" @click="restart()" v-if="activeSection === 4 || showError">Start Again</a>
            </div> <!-- end.action-bar -->

        </div> <!-- end.section-holder -->

        <p class="terms">For Cloud Services that involve syncing data across devices, like backups or media, it is important to have a good upload speed. Please note that the above examples are estimations and can be affected by a number of variables. They should only be used as a guide. If you have any questions about a specific setup, please consult a friendly Afrihost Support member via any of our support channels.</p>

    </div> <!-- end.wizard-holder -->
</template>

<style lang="scss" scoped>
	.action-bar:has(.gwen) {
		display: flex;
		justify-content: center;
		align-items: center;

		.gwen {
			transform: translateY(12px);
			margin-left: 20px;
		}
	}
</style>
